<div 
  class="so-radio-buttons" 
  [class.so-radio-buttons--disabled]="isDisabled()"
  [class.so-radio-buttons--sm]="size() === 'sm'"
  [class.so-radio-buttons--lg]="size() === 'lg'"
  [class.so-radio-buttons--card]="variant() === 'card'"
  [class.so-radio-buttons--button]="variant() === 'button'">
  
  <label *ngIf="label()" class="so-radio-buttons__label">{{ label() }}@if (effectiveRequired()) { <span class="so-radio-buttons__required">*</span>}</label>

  <div
    class="so-radio-buttons__group"
    [ngClass]="layoutClass()"
    [style.gridTemplateColumns]="normalizedColumns() > 1 ? gridTemplateColumns() : null"
    [attr.aria-label]="label() || null"
    role="radiogroup">
    
    <label
      class="so-radio-buttons__option"
      *ngFor="let option of options(); trackBy: trackByValue"
      [class.so-radio-buttons__option--checked]="isChecked(option.value)"
      [class.so-radio-buttons__option--disabled]="isDisabled() || option.disabled">
      
      <input
        type="radio"
        class="so-radio-buttons__input"
        [name]="groupName()"
        [checked]="isChecked(option.value)"
        [disabled]="isDisabled() || option.disabled"
        (change)="selectOption(option)"
        (blur)="handleBlur()" />
      
      <span class="so-radio-buttons__indicator">
        <span class="so-radio-buttons__indicator-dot"></span>
      </span>
      
      <span *ngIf="option.icon" class="so-radio-buttons__icon material-icons">{{ option.icon }}</span>
      
      <span class="so-radio-buttons__content">
        <span class="so-radio-buttons__text" [style.userSelect]="'none'">{{ option.label }}</span>
        <span *ngIf="option.description" class="so-radio-buttons__description">{{ option.description }}</span>
      </span>
    </label>
  </div>
</div>
